import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { DISCORD_URL, LINKEDIN_URL, X_URL, YOUTUBE_URL } from '@app/config';
import { JsonLdService } from '@app/core';
import { FooterComponent, HeaderComponent } from '@app/widgets';
import { environment } from '@env/environment';

@Component({
  selector: 'app-default-layout',
  imports: [FooterComponent, HeaderComponent, RouterOutlet],
  templateUrl: './default-layout.component.html',
  styleUrl: './default-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultLayoutComponent {
  protected readonly consoleBaseUrl = environment.consoleBaseUrl;

  private readonly router = inject(Router);

  constructor(private readonly jsonLdService: JsonLdService) {
    this.jsonLdService.setGlobalStructuredData([
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Capawesome',
        url: 'https://capawesome.io',
        logo: 'https://cloud.capawesome.io/assets/images/logo.webp',
        sameAs: [X_URL, LINKEDIN_URL, DISCORD_URL, YOUTUBE_URL],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Capawesome Cloud',
        url: 'https://cloud.capawesome.io',
      },
    ]);
  }

  get isCompareRoute(): boolean {
    return this.router.url.startsWith('/compare/');
  }

  get isEnterpriseOrTrustRoute(): boolean {
    return (
      this.router.url.startsWith('/enterprise') ||
      this.router.url.startsWith('/trust')
    );
  }

  get isNativeBuildsRoute(): boolean {
    return this.router.url.startsWith('/native-builds');
  }
}
